
import {
  NodeBasicPage,
  NodeParagraphsPage,
  NodeLandingPage,
} from 'src/implementations';

const mappers = {
  basic_page: NodeBasicPage,
  paragraphs_page: NodeParagraphsPage,
  landing_page: NodeLandingPage,
};

export default mappers;
